var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import dynamic from "next/dynamic";
import { NotificationListFallback } from "./NotificationListFallback";
export const LazyNotificationsList = dynamic(() => __awaiter(void 0, void 0, void 0, function* () {
    const { NotificationList } = yield import("./NotificationList");
    return NotificationList;
}), {
    ssr: false, // we don't want to prefetch notifications
    loading: () => _jsx(NotificationListFallback, {}),
});
//# sourceMappingURL=LazyNotificationsList.js.map